var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gip-bg-default",attrs:{"id":"home"}},[_c('div',{staticClass:"gip-max-width"},[_c('Carrousel'),_c('simulateur')],1),_c('Carte'),_c('div',{staticClass:"gip-max-width"},[_c('PourQui'),_c('PlusSurNous'),_c('DernierMembre')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }